import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useLayout } from "../context/LayoutContext";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithCredentials } = useAuth();
  const { setLayoutMode } = useLayout();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    
    const targetPath = loginWithCredentials(username, password);
    
    if (targetPath) {
      // For this prototype, if it's admin, set layout to desktop
      setLayoutMode("desktop");
      navigate(targetPath, { replace: true });
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <Card className="max-w-md w-full p-8 shadow-xl border-t-4 border-indigo-600">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-4">
            <span className="text-2xl font-bold text-indigo-600">A</span>
          </div>
          <h2 className="text-2xl font-bold text-slate-800">
            Adnaki Prototype
          </h2>
          <p className="text-slate-500 mt-2">Please sign in to access the platform</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg text-center">
              {error}
            </div>
          )}
          
          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700 block">Username</label>
            <input
              type="text"
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700 block">Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-lg font-semibold shadow-md transition-all active:scale-[0.98]"
            size="lg"
          >
            Sign In
          </Button>
        </form>
        
        <div className="mt-8 text-center border-t border-slate-100 pt-6">
          <p className="text-xs text-slate-400 uppercase tracking-widest font-semibold mb-3">Internal Access Only</p>
          <div className="inline-flex space-x-4">
             <button type="button" onClick={() => navigate("/")} className="text-sm text-indigo-600 hover:text-indigo-800 transition-colors">Back to Landing Page</button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
